// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"3785a645","199":"fd0c7c28","309":"48f9b326","517":"2624ed9c","608":"fd0c7c28","609":"7272174f","623":"ffcad2bc","798":"1b193e64","875":"ffcad2bc","921":"f74f1982"}[chunkId] + ".chunk.css";
};